<template>
  <el-dialog :visible.sync="form_state" title="Не СПАМ" :append-to-body="true" width="450px">
    <div v-loading="form.busy">
        <button @click.prevent="update" type="button" class="btn btn-primary" :class="{'btn-loading': form.busy, }">Снять метку СПАМ с выделенных заявок ({{ ids.length }})</button>
    </div>
  </el-dialog>
</template>

<script>
import Form from "vform";
import toastr from "toastr";
import RequestStatusData from "../../../plugins/request_status_data";
import RoleData from "../../../plugins/role_data";

export default {
  name: "NotSpam",
  data: () => ({
    ids: [],
    form_state: false,
    form: new Form(),
  }),
  mounted() {
    let self = this;
    this.$bus.$on('notSpamBulk:open-form', ids => {
      self.ids = ids;
      self.form_state = true;
    });
  },
  beforeDestroy() {
    this.$bus.$off('notSpamBulk:open-form');
  },
  watch: {
    form_state(val) {
      this.resetData();
    }
  },
  methods: {
    async update() {
      let self = this;
      if (this.validate()) {
        this.form.ids = this.ids;

        this.form.post('/api/requests/notSpamBulk')
            .then(r => {
              self.$message.success({
                message: 'Успешно',
                duration: 2000,
              });
              self.resetData();
              self.form_state = false;
            });
      }
    },
    resetData() {
      this.form = new Form();
    },
    validate: function () {
      this.form = new Form();
      return true;
    },
  }
}
</script>

<style scoped>

</style>
